import { useMutation } from "react-query";
import { Button, Container, Form, Stack, Text } from "basis";
import { postHref, putHref } from "library/api";
import { CreditCard } from "../CreditCard/CreditCard";
import { OneTimeCode } from "../OneTimeCode/OneTimeCode";
import { SvgInline } from "../SvgInline/SvgInline";

const initialValues = {
  oneTimeCode: "",
};

function SetPinOneTimeCode({ state, dispatch }) {
  const {
    accountInfo,
    maskedMobileNumber,
    encodedPinBlock,
    rsaId,
    finalisePinChangeAction,
    resendOtpAction,
  } = state;
  const finalisePinChangeMutation = useMutation(
    ({ oneTimeCode }) =>
      putHref(finalisePinChangeAction.href, {
        rsa_id: rsaId,
        encoded_pin_block: encodedPinBlock,
        otp_code: oneTimeCode,
      }),
    {
      onSuccess: () => {
        dispatch({
          type: "ONE_TIME_CODE_VERIFIED_SUCCESSFULLY",
        });
      },
      onError: (error, { setErrors }) => {
        const errorType = error.response?.data?.type ?? null;

        switch (errorType) {
          case "BAD_REQUEST": {
            setErrors({
              oneTimeCode: "Invalid code",
            });
            break;
          }

          default: {
            dispatch({
              type: "ONE_TIME_CODE_VERIFICATION_FAILED",
            });
          }
        }
      },
    },
  );
  const onSubmit = ({ errors, values, setErrors }) => {
    if (Object.keys(errors).length === 0) {
      const { oneTimeCode } = values;

      finalisePinChangeMutation.mutate({
        oneTimeCode,
        setErrors,
      });
    }
  };

  return (
    <Form initialValues={initialValues} onSubmit={onSubmit}>
      <Stack gap="8">
        <Container bg="grey.t05" padding="4">
          <CreditCard
            cardName={accountInfo.cardName}
            cardEndsWith={accountInfo.cardEndsWith}
          />
        </Container>
        <SvgInline name="icon-security-lock" size="92" />
        <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
          Verify your identity
        </Text>
        <OneTimeCode
          otpRecipient={maskedMobileNumber}
          resendMutationFn={() => postHref(resendOtpAction.href)}
          onResendCodeError={() => {
            dispatch({
              type: "ONE_TIME_CODE_RESEND_FAILED",
            });
          }}
        />
        <Button
          type="submit"
          width="160"
          loading={finalisePinChangeMutation.isLoading}
        >
          Next
        </Button>
      </Stack>
    </Form>
  );
}

export { SetPinOneTimeCode };
